import React, { useState, useRef } from 'react';
import cn from 'classnames';
import { Button } from '@base/lib/Button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { isPhone } from 'base/utils/client';
import { BannerText } from './BannerText';
import { ProductLists } from './ProductLists';
import { getModuleCode, getModuleElementId, getWrapBgStyle, getWrapSpaceStyle, getWrapStyle } from 'base/utils/features'
import { IThemeSwiperRef } from '@base/lib/ThemeSwiper'
import {
    IFeatureTabsProducts,
    IReview,
    ITabsItem
} from 'mod/feature/interface';
import titleStyles from 'app/styles/modules/title.module.less';
import homeStyles from '@app/shop/index.module.less';
import styles from './index.module.less';
import ModuleTitle from '@base/lib/ModuleTitle'

type IProps = {
    data: IFeatureTabsProducts;
}

const listsAddRowKey = (lists: Record<string, any>[]) => {
    return lists?.map((item: any, index) => {
        return {
            ...item,
            rowKey: `${index}`,
        }
    });
}

const TabsProducts: React.FC<IProps> = (props) => {
    const { data } = props

    const moduleCode = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);

    const swiperRef = useRef<IThemeSwiperRef>(null);
    const [reviewItem, setReviewItem] = useState<IReview>();
    const [detailVisible, setDetailVisible] = useState<boolean>(false)

    const {
        config: {
            width,
            height,
            listLimit,
            columnWidth,
            elements
        },
    } = data;

    let { lists } = data
    lists = listsAddRowKey(lists)

    const [selectedTab, setSelectedTab] = useState<ITabsItem>(lists[0])

    const onClickItem = (item: IReview) => {
        setReviewItem(item)
        setDetailVisible(true)
    }

    const onCloseDetailModal = () => {
        setDetailVisible(false)
    }
    return (
        <div id={moduleElementId}
             data-t-mod={moduleCode}
             style={{
                 ...getWrapBgStyle(data.background),
                 ...(!!selectedTab ? getWrapBgStyle(selectedTab?.background) : {}),
             }}
             className={cn(
                 styles['tabs-products'],
                 selectedTab.showType == 'dark' ? styles['dark'] : styles['light']
             )}
        >
            <div
                style={getWrapSpaceStyle(data.space)}
                className={cn(homeStyles.wrapper)}
            >
                <ModuleTitle
                    className={cn(titleStyles.title, homeStyles.title)}
                    text={data.title}
                    link={data.readMoreLink}
                    linkText={data.readMoreTitle}
                    moduleCode={moduleCode}
                />

                <div>
                    {/* tab label*/}
                    <Swiper
                        pagination={false}
                        slidesPerView={'auto'}
                        className={'g-nav'}
                        spaceBetween={24}
                        // centeredSlides={true}
                    >
                        {lists?.map((tabItem, tabIndex) => (
                            <SwiperSlide
                                key={tabIndex}
                                className={cn(
                                    'g-nav-item',
                                    { ['g-active']: tabItem.label?.text === selectedTab?.label?.text }
                                )}
                            >
                                <Button
                                    className={cn(
                                        'g-label',
                                        { ['g-label-on']: tabItem.rowKey === selectedTab?.rowKey }
                                    )}
                                    type={'base'}
                                    key={tabIndex}
                                    onClick={() => setSelectedTab(tabItem)}
                                >
                                    {tabItem.label?.text}
                                </Button>
                            </SwiperSlide>
                        ))}
                    </Swiper>


                    {/* tab 内容 */}
                    <BannerText
                        bannerProps={{
                            width,
                            height,
                        }}
                        className={styles['banner-text']}
                        tabItem={selectedTab}
                    />

                    <ProductLists listLimit={listLimit} columnWidth={columnWidth} elements={elements} tabItem={selectedTab}/>

                </div>

            </div>

        </div>
    );
};

export default TabsProducts;